// extracted by mini-css-extract-plugin
export default {"button":"BXuBH","increment":"ww2tN","decrement":"N5jaj"};